export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo: 'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: 'Page de paiement sécurisé',
      description: 'Nous gardons vos informations financières sécurisées et cryptées',
      methodErrorTips: "Désolé, le pays que vous avez sélectionné n'est actuellement pas pris en charge. Veuillez sélectionner un autre pays et réessayez.",
      recommendation: 'Recommandation',
      cardNumber: 'Numéro de carte',
      cardName: 'Nom sur la carte',
      cvv: 'CVV',
      expiredDate: "Date d'expiration",
      billingInfo: 'Informations de facturation',
      country: 'Pays',
      state: 'État',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      document: 'Document',
      city: 'Ville',
      address: 'Adresse',
      streetNumber: 'Numéro de rue',
      zipCode: 'Code postal',
      email: 'E-mail',
      phone: 'Numéro de téléphone',
      pay: 'PAYER',
      choosePaymentMethod: 'Choisissez le mode de paiement',
      continue: 'Continuer',
      later: 'Plus tard',
      returnToMerchant: 'Annuler et retourner au commerçant',
      resultToMerchant: 'Retourner au commerçant',
      orderId: 'ID de commande',
      orderAmount: 'Montant de la commande',
      billingDescriptor: 'Descripteur de facturation',
      goodsName: 'Nom du produit',
      timeLimit: 'Veuillez terminer le paiement dans le délai imparti, sinon la page expirera',
      otherPaymentMethods: 'Autres méthodes de paiement',
      close: 'Fermer',
      paymentErrorTitle: 'Échec du paiement',
      paymentErrorTip: "Votre paiement n'a pas été traité avec succès. Veuillez réessayer.",
      paymentFailed: 'Le processus de paiement a échoué',
      continueShopping: 'Continuer vos achats',
      paymentSuccess: 'Le processus de paiement a été réalisé avec succès',
      paymentPending: 'Paiement envoyé, en cours de confirmation',
      correctDateTip: "Veuillez saisir une date d'expiration valide",
      correctCardNumberTip: 'Veuillez saisir un numéro de carte valide',
      correctSecurityCodeTip: 'Veuillez entrer un code de sécurité valide',
      mobileMoneyOperator: "Opérateur d'argent mobile",
      bank: 'Banque',
      correctEmailAddressTip: 'Veuillez entrer une adresse e-mail valide',
      notSupportPaymentTip: "L'environnement actuel ne prend pas en charge le paiement {type}",
      addValidPaymentCard: 'Veuillez ajouter une carte de paiement valide',
      timeLimitTip: "Des frais seront prélevés 12 heures avant la fin de la période d'essai (<span class=\"date\">{date}</span>), puis le renouvellement sera effectué tous les <span class=\"date\">{month}</span> mois pour <span class=\"amount\"> {amount} {currency}</span>, vous pouvez annuler à tout moment",
      product: 'Produit/Service',
      subscribeType: 'Type d\'abonnement',
      renewCycle: 'Cycle de renouvellement',
      renewAmount: 'Montant du renouvellement',
      subscribePay: 'S\'abonner et payer',
      readAgreement: "Lire et accepter<span class='protocol-link' style='color: #31a7da;'>l'Accord de renouvellement automatique</span>",
      depict: 'Description',
      copyQrCode: 'Copier QR-Code',
      copySuccess: 'QR-Code copié avec succès',
      copyError: 'QR-Code non copié',
      refreshQrCode: 'Actualiser QR-Code'
    },
    subscribe: {
      yourSubscribe: 'Votre abonnement',
      unsubscribeTip: 'Pour annuler, cliquez sur le bouton [Annuler l\'abonnement] en bas de la page.',
      renewTip: 'Prélèvement de <span class="amount"> {amount} {currency}</span> le <span class="date">{date}</span>, annulable à tout moment',
      unsubscribe: 'Annuler l\'abonnement',
      autoRenew: 'Accord de renouvellement automatique',
      unsubscribeTipTwo: 'Si vous annulez maintenant, vous pourrez toujours utiliser cet abonnement jusqu\'au <span class="date">{date}</span>.',
      emailVerifyTip: 'Vérification de l\'e-mail',
      inputCodeTip: 'Veuillez saisir le code de vérification',
      sendSuccessTip: 'Code de vérification envoyé avec succès',
      sendErrorTip: 'Échec de l\'envoi du code de vérification',
      unsubscribeSuccessTip: 'Abonnement annulé avec succès',
      unsubscribeErrorTip: 'Échec de l\'annulation de l\'abonnement',
      sendCodeTip: 'Renvoyer dans {code} secondes',
      sendEmailTip: 'Obtenir le code de vérification',
      daily: 'Tous les jours',
      weekly: 'Tous les 7 jours',
      monthly: 'Tous les 30 jours',
      quarterly: 'Tous les 90 jours',
      semiAnnually: 'Tous les 180 jours',
      annually: 'Tous les 365 jours',
      regularRenewal: 'Renouvellement régulier',
      oneTime: 'Unique',
      inputNumberTip: 'Veuillez entrer uniquement des chiffres',
      eachCalendarMonth: 'Chaque mois calendaire'
    },
    common: {
      confirm: 'Confirmer',
      cancel: 'Annuler',
      uploadImgErrorTip: 'Seules les images peuvent être téléchargées',
      inputMessageTip: 'Veuillez remplir le contenu',
      sendSuccessTip: 'Envoi réussi',
      sendErrorTip: "Échec de l'envoi",
      inputPlaceholder: 'Veuillez saisir {field}',
      selectPlaceholder: 'Veuillez sélectionner {field}',
      correctFormat: 'Veuillez saisir le format correct, par exemple : {example}'
    }
  }
}
